import { GenericHttpClient } from "./config/http.generic.client";
import { useSessionStore } from "../../Stores/Session";
import { useConfigStore } from "../../Stores/Config";

export interface ChangelogComment {
  id?: string;
  _id?: string;
  replyTo?: string;
  createdAt?: string;
  data?: { content?: any };
  session?: { _id?: string; name?: string; avatar?: string };
  user?: { firstName?: string; lastName?: string; profileImageUrl?: string };
  replies?: ChangelogComment[];
}

// Changelog comments live on the feedback portal API, which the widget reaches
// like feature requests do: the portal domain as api-token, the visitor's
// signed session as gleap-id/gleap-hash (#149751).
export class HttpChangelogService extends GenericHttpClient<any> {
  static _instance: HttpChangelogService;
  static getInstance(): HttpChangelogService {
    if (this._instance == null) {
      this._instance = new HttpChangelogService(
        "/v3/shared/feedback-portal/changelogs",
      );
    }
    return this._instance;
  }

  protected injectToken(
    headers: Record<string, string | boolean>,
  ): Record<string, string | boolean> {
    const { session } = useSessionStore.getState();
    const { config } = useConfigStore.getState();

    if (config.defaultDomainHelpCenter) {
      headers["api-token"] = config.defaultDomainHelpCenter;
    }

    if (session && session.gleapId) {
      headers["gleap-id"] = session.gleapId;
    }

    if (session && session.gleapHash) {
      headers["gleap-hash"] = session.gleapHash;
    }

    return headers;
  }

  async getComments(changelogId: string): Promise<ChangelogComment[]> {
    const response = await this.get<ChangelogComment[]>(
      `${this.path}/comments/${changelogId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  }

  async addComment(changelogId: string, comment: any): Promise<void> {
    await this.post<any>(`${this.path}/comments`, {
      changelogId,
      comment: JSON.stringify(comment),
    });
  }
}
